/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import { displayMessage, postAPI, getAPI } from "../../../utils/common";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../../constants/messages";
import { PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import LayoutHeader from "../../inc/LayoutHeader";
import LayoutFooter from "../../inc/LayoutFooter";
import { Space, Button, Card, Popconfirm, Layout, Table, Input } from "antd";

import { ALL_LAUNDRY_ITEM, DELETE_LAUNDRY_ITEM } from "../../../constants/api";

function ItemTable() {
  const { Content } = Layout;
  const navigate = useNavigate();

  const [state, setState] = useState([]);
  const [filteredState, setFilteredState] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");

  useLayoutEffect(() => {
    getList();
  }, []);

  const getList = () => {
    setLoading(true);

    const successFn = (data) => {
      if (data.status === true) {
        const formatted = data.data.map((row, index) => ({
          key: index,
          ID: index + 1,
          ItemCode: row.item_code,
          Name: row.name,
          Rate: `₹ ${row.unit_rate}`,
          Action: (
            <Space>
              <Button
                size="small"
                onClick={() => navigate("/laundry/item/view/" + row.id)}
              >
                View
             </Button>
              <Button onClick={() => navigate("/laundry/item/edit/" + row.id)}>
                Edit
              </Button>
              <Popconfirm
                title="Delete Item"
                onConfirm={() => deleteData(row.id)}
              >
                <Button danger>Delete</Button>
              </Popconfirm>
            </Space>
          ),
        }));

        setState(formatted);
        setFilteredState(formatted);
      } else {
        setState([]);
        setFilteredState([]);
      }
      setLoading(false);
    };

    const errorFn = () => {
      setState([]);
      setFilteredState([]);
      setLoading(false);
    };

    getAPI(ALL_LAUNDRY_ITEM, successFn, errorFn, {});
  };

  const deleteData = (id) => {
    setLoading(true);

    postAPI(
      DELETE_LAUNDRY_ITEM,
      { id },
      (data) => {
        if (data.status === true) {
          displayMessage(SUCCESS_MESSAGE, data.message);
          getList();
        } else {
          setLoading(false);
          displayMessage(ERROR_MSG_TYPE, data.message);
        }
      },
      () => {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, "Unable to delete item");
      }
    );
  };

  const handleSearch = (value) => {
    setSearchText(value);
    setFilteredState(
      state.filter((d) => d.Name.toLowerCase().includes(value.toLowerCase()))
    );
  };

  const columns = [
    { title: "S.No", dataIndex: "ID", width: 70 },
    { title: "Item Code", dataIndex: "ItemCode", width: 150 },
    { title: "Item Name", dataIndex: "Name", width: 200 },
    { title: "Unit Rate", dataIndex: "Rate", width: 150 },
    { title: "Action", dataIndex: "Action", width: 150 },
  ];

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card
          title="Laundry Item Master"
          extra={
            <Space>
              <Input
                placeholder="Search Item"
                value={searchText}
                onChange={(e) => handleSearch(e.target.value)}
                style={{ width: 300 }}
              />
              <Button onClick={() => navigate("/laundry/item/add")}>
                Add <PlusOutlined />
              </Button>
            </Space>
          }
        >
          <Table
            loading={loading}
            columns={columns}
            dataSource={filteredState}
            pagination={{ pageSize: 10 }}
          />
        </Card>
      </Content>
      <LayoutFooter />
    </Layout>
  );
}

export default ItemTable;
